<template>

<div class="page work">

  <!-- MAIN LANDING SECTION -->
	<transition name="slide-up-in" appear>
	<section id="landing" class="block-image-hero">
		<!-- <div class="container"> -->
			<ts-image :src="image1.url" :width="image1.size[0]" :height="image1.size[1]" :bg-color="image1.bgColor"></ts-image>
		<!-- </div> -->
	</section>
	</transition>


	<!-- TEXT -->
	<section id="section-1" class="block-text-overview">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-5" data-sal="slide-up" data-sal-delay="600" data-sal-duration="600" data-sal-easing="ease">
					<p class="meta">Data Visualisation</p>
					<h2>Wired Magazine.</br>Data Visualisation</h2>
					<p>Wired UK Magazine reports on the modern day effects of science and technology in the world. They cover a broad range of topics including design, architecture, culture, the economy, politics and philosophy.</p>
					<p>Back in 2014 in the beginning of StudioDotInfo we were approached by Wired Magazine to help create various infographics and data visualisations for the 'Infoporn' features. The data visualisations included world city weather data and predicting the next pop hit.</p>
					<p>Still remains one of my favourite pieces as it was the first time using code to plot the data accurately (scales and heatmaps) and then apply the finishing touches with design software.</p>
				</div>
			</div>
		</div>
		<div class="text-border col-xs-12 col-sm-12 offset-md-1 col-md-12 offset-lg-5 col-lg-6"></div>
	</section>


	<!-- TEXT -->
	<section id="section-2" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h4>Forecast: Unsettled</h4>
					<p>The data visualisations show weather patterns from around the world using the daily average minimum, maximum temperatures (coloured bars) and daily average rainfall (circles) over the last 30-years.</p>
				</div>
			</div>
		</div>
	</section>


	<!-- IMAGE -->
	<section id="section-3" class="block-image full multiple">
		<!-- IMAGE 2 -->
    <ts-image :src="image2.url" :width="image2.size[0]" :height="image2.size[1]" :bg-color="image2.bgColor" dark-loader></ts-image>
		<!-- IMAGE 3 -->
    <ts-image :src="image3.url" :width="image3.size[0]" :height="image3.size[1]" :bg-color="image3.bgColor"></ts-image>
		<!-- DOWN ARROW -->
		<div class="down-arrow"></div>
	</section>


	<!-- TEXT -->
	<section id="section-4" class="block-text-content">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 col-sm-12 offset-md-4 col-md-7 offset-lg-5 col-lg-4" data-sal="slide-up" data-sal-delay="0" data-sal-duration="600" data-sal-easing="ease">
					<h4>Data That Can</br>Predict a Pop Hit</h4>
					<p>The infographic explores whether activity on social media sites can be used to predict the next big music artist.</p>
					<p>The charts show a clear correlation between an artist's social media activity and success in the 'Billboard 200' music chart. The intelligence behind data used algorithms from music analytics company Next Big Sound.</p>
				</div>
			</div>
		</div>
	</section>


  <!-- IMAGE -->
	<section id="section-5" class="block-image full multiple">
		<!-- IMAGE 4 -->
    <ts-image :src="image4.url" :width="image4.size[0]" :height="image4.size[1]" :bg-color="image4.bgColor" dark-loader></ts-image>
		<!-- IMAGE 5 -->
    <ts-image :src="image5.url" :width="image5.size[0]" :height="image5.size[1]" :bg-color="image5.bgColor"></ts-image>
	</section>

  <ts-footer></ts-footer>


</div>


</template>


<script>

// @ is an alias to /src
import sal from 'sal.js'
import TsImage from '@/components/TSImage.vue'
import TsFooter from '@/components/TSFooter.vue'

import Image1 from "@/assets/images/works/wiredmagazine/500-image-1.jpg"
import Image2 from "@/assets/images/works/wiredmagazine/500-image-2.jpg"
import Image3 from "@/assets/images/works/wiredmagazine/500-image-3.jpg"
import Image4 from "@/assets/images/works/wiredmagazine/500-image-4.jpg"
import Image5 from "@/assets/images/works/wiredmagazine/500-image-5.jpg"

export default {

  name: 'WorksWiredMagazine',

  data() {
    return {
      image1: {
        url: Image1,
        size: [2190,1800],
        bgColor: "none"
      },
      image2: {
        url: Image2,
        size: [2880,1440],
        bgColor: "none"
      },
      image3: {
        url: Image3,
        size: [2880,1956],
        bgColor: "none"
      },
      image4: {
        url: Image4,
        size: [2880,1440],
        bgColor: "none"
      },
      image5: {
        url: Image5,
        size: [2880,1956],
        bgColor: "none"
      }
    }
  },

  components: {
    TsImage,
    TsFooter
  },

	mounted() {
    this.$root.$emit('show-shapes', false)
		sal({threshold: 0.10});
  }

}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@import "~@/assets/scss/_variables";
@import "~@/assets/scss/grid/_bootstrap-grid";

section#landing {
	.ts-image {
		// float: left;
		width: 75%;
	}
}

section#section-2 {
	.container {
		padding-top: 0px;
	}
}

span.hero-background {
	background-color: #FF5F59;
}
span.background {
	background-color: #FF5F59;
}

</style>
